import type { ReactNode } from "react"
import React from "react"

import TripSummaryBarWithDrawer from "~components/pages/listing/checkout/trip-summary-bar-with-drawer"
import BookingSummary from "~components/pages/book/booking-summary"
import type {
    QuoteInterfaceFieldsFragment,
    QuoteListingFieldsFragment,
} from "~graphql/generated/graphql"
import type { OnEditPackageClickFunc } from "~components/shared/quote/quote-package-buttons"

interface Props {
    readonly quote?: QuoteInterfaceFieldsFragment | null
    readonly listing: QuoteListingFieldsFragment
    readonly isLoading?: boolean
    readonly shouldShowDeleteButtons?: boolean
    readonly onEditPackageClick?: OnEditPackageClickFunc
    readonly renderNavButtons?: () => ReactNode
}

export default function CheckoutSummaryDrawer({
    quote,
    listing,
    isLoading,
    shouldShowDeleteButtons,
    onEditPackageClick,
    renderNavButtons,
}: Props) {
    return (
        <TripSummaryBarWithDrawer
            total={quote?.total}
            isLoading={isLoading}
            renderNavButtons={renderNavButtons}
        >
            <BookingSummary
                listing={listing}
                quote={quote}
                isQuoteLoading={isLoading}
                shouldShowDeleteButtons={shouldShowDeleteButtons}
                onEditPackageClick={onEditPackageClick}
                shouldShowProcessingFeeWarning={true}
            />
        </TripSummaryBarWithDrawer>
    )
}
